import React, {useState} from 'react';
import {Provider} from "react-redux";
import configure from "../../../store/configure";
import CashChargedHistoryComp from "../container/CashChargedHistoryComp";
import Layout from "../../../component/layout/Layout";

const CashChargedHistoryPage = () => {

    return (
        <Provider store={configure}>
            <Layout>
                <CashChargedHistoryComp />
            </Layout>
        </Provider>
    );
};

export default CashChargedHistoryPage;
